var map = {
	"./1.jpg": "3214",
	"./10.jpg": "ef42",
	"./2.jpg": "49c7",
	"./3.jpg": "5cf5",
	"./4.jpg": "2ec8",
	"./5.jpg": "8d68",
	"./6.jpg": "2eef",
	"./7.jpg": "b762",
	"./8.jpg": "862e",
	"./9.jpg": "65eda"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fbd6";